/// <amd-module name="Feed/Legacy/Protocols/PyPi/PyPiPackagePeople" />
import * as React from "react";

import { IVssPageContext } from "VSS/Platform/Context";

import * as PackageResources from "Feed/Common/Resources";
import { IPerson } from "Feed/Legacy/Protocols/Common/IPerson";
import { PackageAttribute } from "Feed/Legacy/Protocols/Components/PackageAttribute";
import { PackagePerson } from "Feed/Legacy/Protocols/Components/PackagePerson";

export interface IPyPiPackagePeopleProps {
    pageContext: IVssPageContext;
    author: string;
    authorEmail: string;
    maintainer: string;
    maintainerEmail: string;
}

export class PyPiPackagePeople extends React.PureComponent<IPyPiPackagePeopleProps> {
    public render(): JSX.Element {
        if (!this.props.author && !this.props.maintainer) {
            return null;
        }

        return (
            <div className="pypi-package-people">
                <PackageAttribute title={PackageResources.PackagePeople_Title}>
                    {this.props.author && (
                        <div>
                            <div className="package-group-header" role="heading" aria-level={3}>
                                {PackageResources.PackagePeople_Author}
                            </div>
                            <PackagePerson
                                pageContext={this.props.pageContext}
                                key={this.props.author}
                                person={this.ToPerson(this.props.author, this.props.authorEmail)}
                            />
                        </div>
                    )}
                    {this.props.maintainer && (
                        <div>
                            <div className="package-group-header" role="heading" aria-level={3}>
                                {PackageResources.PyPiPackagePeople_Maintainer}
                            </div>
                            <PackagePerson
                                pageContext={this.props.pageContext}
                                key={this.props.maintainer}
                                person={this.ToPerson(this.props.maintainer, this.props.maintainerEmail)}
                            />
                        </div>
                    )}
                </PackageAttribute>
            </div>
        );
    }

    private ToPerson(name: string, email: string): IPerson {
        return {
            name: name,
            email: email,
            url: null
        } as IPerson;
    }
}
